<template>
  <div class="form-container sign-in-container" id="auth-modal-content">
    <loading class="register-overlay" v-show="showLoader" />

    <form @submit.prevent="handleSignupSubmit">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center pb-4"><img alt="Logo Icon" class="img-fluid" :src="require('@/assets/images/ib-logo.svg')" /></div>
        </div>

        <div class="row my-2 ib-default-align" style="min-height:12rem;">
          <div class="col-md-6 align-self-lg-start order-2 order-lg-1">
            <div>
              <div class='profile-upload-img' id="signup-acq-profile-img" :style="{ backgroundImage: 'url(' + form.avatar + ')' }">
                <div class="hvr-profile-img"><input type="file" accept="image/*" class="upload w180" @change="readUrl($event)"></div>
                <div class="fa">Upload Image</div>
              </div>
              <div v-if="errors.filter(x => x.field == 'avatar').length > 0">
                <div class="d-block jbl-text-danger" style="margin-top: 15px;">
                  <small class="text-danger">{{errors.filter(x => x.field == 'avatar')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-center text-lg-right order-1 order-lg-2">
            <h1 class="login-title text-center text-lg-right in-md-mb" style="margin-top:0 !important;">Sign Up</h1>
            <h5 class="ib-login-text text-center text-lg-right" style="margin-bottom:30px !important;">Please Sign Up to Your account</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">First Name<span>*</span></label>
                <input type="text" class="ib-login-input" name="first_name" v-model="form.first_name" placeholder="Enter First Name" pattern="[a-zA-Z ]+" title="Only Alphabets">
              </div>

              <div v-if="errors.filter(x => x.field == 'first_name').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'first_name')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">Last Name<span>*</span></label>
                <input type="text" class="ib-login-input" name="last_name" v-model="form.last_name" placeholder="Enter Last Name" pattern="[a-zA-Z ]+" title="Only Alphabets">
              </div>

              <div v-if="errors.filter(x => x.field == 'last_name').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'last_name')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
          <!--          <div class="col-md-6">-->
          <!--            <div>-->
          <!--              <div class="jbl-field-sign">-->
          <!--                <label class="jbl-label-sign">Middle Name</label>-->
          <!--                <input type="text" class="ib-login-input" name="middle_name" v-model="form.middle_name" placeholder="Enter Middle Name (Optional)" pattern="[a-zA-Z ]+" title="Only Alphabets">-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>

        <div class="row">
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">Username<span>*</span></label>
                <input type="text" class="ib-login-input" name="username" pattern="[a-zA-Z0-9]+" title="Only Alphabets And Numbers" v-model="form.username" minlength="5" maxlength="50" placeholder="Enter Username">
              </div>

              <div v-if="errors.filter(x => x.field == 'username').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'username')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">Email<span>*</span></label>
                <input type="email" class="ib-login-input" name="email" v-model="form.email" @change="verifyEmail($event)" placeholder="Enter Email">
              </div>

              <div v-if="errors.filter(x => x.field == 'email').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'email')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">Password<span>*</span></label>
                <input type="password" id="signup_acq_passsword" class="ib-login-input" name="password" v-model="form.password" placeholder="Enter Password" autocomplete="off">
                <span id="signup_acq_eye" class="fa fa-fw fa-eye field-icon toggle-password in-eye-btn" @click="tooglePasswordView()"></span>
              </div>

              <div v-if="errors.filter(x => x.field == 'password').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'password')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">Confirm Password<span>*</span></label>
                <input type="password" id="signup_acq_conf_passsword" class="ib-login-input" name="confirm_password" v-model="form.confirm_password" placeholder="Enter Confirm Password" autocomplete="off">
                <span id="signup_acq_conf_eye" class="fa fa-fw fa-eye field-icon toggle-password in-eye-btn" @click="toogleConfirmPasswordView()"></span>
              </div>

              <div v-if="errors.filter(x => x.field == 'confirm_password').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'confirm_password')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div>
              <div class="jbl-field-sign">
                <label class="jbl-label-sign">Mobile Number<span>*</span></label>
                <input v-mask="'+92##########'" type="text" class="ib-login-input" v-model="form.mobile_no" @input="validateMobileNo($event, 'beneficiary', '')" placeholder="Enter Mobile Number"/>
              </div>

              <div v-if="errors.filter(x => x.field == 'mobile_no').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'mobile_no')[0].message}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="display:block; text-align:center;">
          <button type="submit" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4 mx-auto">Sign Up</button>
        </div>
        <div style="display:block; text-align:center;">
          <h6>Already a User<span>?</span> Please <span class="ib-cursor-pointer" style="color:#ef7c94;" @click="closeSignUpOpenSignInModal()">Sign In</span></h6>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import VuePhoneNumberInput from 'vue-phone-number-input';
  import MaskedInput from 'vue-masked-input';
  import loading from '@/components/Loading/Loading';
  import { mask } from 'vue-the-mask';

  export default {
    name: "SignUp",
    components: {
      VuePhoneNumberInput,
      MaskedInput,
      loading
    },
    directives: { mask },
    data () {
      return {
        showLoader : false,
        form: {
          first_name: "" ,
          //middle_name: "" ,
          last_name: "" ,
          username: "",
          email: "",
          password: "",
          confirm_password: "",
          mobile_no: "",
          avatar: ""
        },
        errors: []
      };
    },
    methods: {
      ...mapActions(["SignUp"]),
      async handleSignupSubmit(e) {
        const self = this;
        self.errors = [];
        Object.entries(self.form).forEach(([key, value]) => {
          if (key != 'middle_name' && key != 'avatar' && value == '') {
            if(key == 'avatar') {
              // self.errors.push({
              //   field: key,
              //   message: 'Profile Image required'
              // });
            } else {
              self.errors.push({
                field: key,
                message: key.replace(/_/g,' ') + ' required'
              });
            }
          }
        });

        if(self.form.password.length < 6) {
          self.errors.push({
            field: 'password',
            message: 'Minimum 6 characters required for password'
          });
        }
        if(self.form.confirm_password.length < 6) {
          self.errors.push({
            field: 'confirm_password',
            message: 'Minimum 6 characters required for confirm password'
          });
        }
        if(self.form.username.length < 5 || self.form.username.length > 50) {
          self.errors.push({
            field: 'username',
            message: 'Username length must be between 5 and 50'
          });
        }
        if(self.form.password != self.form.confirm_password) {
          self.errors.push({
            field: 'confirm_password',
            message: 'Password must match confirm password'
          });
        }
        if(self.form.mobile_no.length < 13) {
          self.errors.push({
            field: 'mobile_no',
            message: 'Incorrect Mobile Number'
          });
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(self.form.email).toLowerCase());
        if(!result) {
          self.errors.push({
            field: 'email',
            message: 'Invalid Email'
          });
        }

        if (self.errors.length > 0) {
          return false;
        }

        self.showLoader = true;
        await self.SignUp(self.form).then((response) => {
          if(response.data.code == 200) {
            self.showLoader = false;
            self.$root.$emit('updateUser');
            self.$root.$emit('closeSignUpModal');
            self.$root.$emit('showVerifyEmailModal');
            $toast.success('Sign up successfully', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            return false;
          }
          self.showLoader = false;
        }).catch(error => {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      validateMobileNo(event, step, key) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            event.target.value = '+92';
            self.form.mobile_no = '+92';
          }
        }
      },
      verifyEmail(event) {
        const self = this;

        self.errors = [];
        let email = event.target.value;
        if(email == '') {
          return false;
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(email).toLowerCase());
        if(!result) {
          self.errors.push({
            field: 'email',
            message: 'Invalid Email'
          });
        }
      },
      readUrl(e) {
        const self = this;
        if(e.target.files.length > 0) {
          var file = e.target.files[0];
        } else {
          return false;
        }

        if(file['type'].split('/')[0] != 'image') {
          $toast.error('Only image files are accepted', { position: 'top-right' });
          return false;
        } else if (file.size > 5000000) {
          $toast.error('Upload file less than 5Mb', { position: 'top-right' });
          return false;
        }

        var reader = new FileReader();
        reader.onloadend = function() {
          document.getElementById('signup-acq-profile-img').style.backgroundImage = "url(" + reader.result + ")";
        }

        if(file) {
          reader.readAsDataURL(file);
          self.form.avatar = file;
        }
      },
      closeSignUpOpenSignInModal() {
        const self = this;
        self.errors = [];
        self.$root.$emit('showLoginCloseSignUpModal');
      },
      tooglePasswordView() {
      var input = document.getElementById('signup_acq_passsword');
      var eye = document.getElementById('signup_acq_eye');

      if (input.getAttribute("type") == "password") {
        input.setAttribute("type", "text");
        eye.classList.remove('fa-eye');
        eye.classList.add('fa-eye-slash');
      } else {
        input.setAttribute("type", "password");
        eye.classList.remove('fa-eye-slash');
        eye.classList.add('fa-eye');
      }
    },
    toogleConfirmPasswordView() {
      var input = document.getElementById('signup_acq_conf_passsword');
      var eye = document.getElementById('signup_acq_conf_eye');

      if (input.getAttribute("type") == "password") {
        input.setAttribute("type", "text");
        eye.classList.remove('fa-eye');
        eye.classList.add('fa-eye-slash');
      } else {
        input.setAttribute("type", "password");
        eye.classList.remove('fa-eye-slash');
        eye.classList.add('fa-eye');
      }
    }
    }
  };
</script>

<style scoped>
  @font-face {
    font-family: 'Futura PT Medium';
    src: url('~@/assets/fonts/futura-pt-medium.otf') format('otf');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Futura PT Demi';
    src: url('~@/assets/fonts/futura-pt-w01-demibold.ttf') format('ttf');
    font-weight: bold;
    font-style: normal;
  }

  .jbl-field-sign {
    margin-bottom: .7rem !important;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/Auth/SignUpAcquisition.vue